import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-use-form-state';
//Using Show Validation for now
import { ShowValidator } from '@shoflo/polymer/validators/ShowValidator/ShowValidator';
import { Input, Form, FormGroup, FormFeedback } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
import styled from 'styled-components';

import { getFileExtension, getFileNameWithoutExtension } from './fsObjectUtils';

import StyledFormLabel from 'components/form/StyledFormLabel';

const ActionButtonWrapper = styled.div`
  float: right;
  margin-top: 18px;
`;

const StyledInput = styled(Input)`
  width: 80%;
`;

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  span {
    white-space: pre;
  }
`;

const RenameEventDocForm = (props) => {
  const { onSubmit, onCancel, name } = props;

  const extension = getFileExtension(name);

  const [formState, { text, label }] = useFormState({
    name: getFileNameWithoutExtension(name),
  });

  const { touched, validity, values } = formState;

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        let { title } = values;
        //remove extension if added
        title = getFileNameWithoutExtension(title);
        const changes = {
          name: `${title}${extension}`,
          isStudioMedia: false,
        };
        onSubmit(changes);
      }}
    >
      <FormGroup>
        <StyledFormLabel
          id="eventDocTitleInputLabel"
          htmlFor="eventDocTitleInput"
          {...label('title')}
        >
          Name
        </StyledFormLabel>
        <FlexWrapper>
          <StyledInput
            id="eventDocTitleInput"
            aria-labelledby="eventDocTitleInputLabel"
            placeholder={getFileNameWithoutExtension(name)}
            {...text({
              name: 'title',
              validate: ShowValidator.title,
              touchOnChange: true,
            })}
            invalid={touched.title && !validity.title}
            required
          />
          <span> {extension}</span>
        </FlexWrapper>
        {validity.title === false && (
          <FormFeedback>
            Uh oh! EventDoc names must be between 2 and 64 characters.
          </FormFeedback>
        )}
      </FormGroup>
      <ActionButtonWrapper className="modal-footer">
        <Button color="primary" disabled={!validity.title}>
          Save
        </Button>{' '}
        <Button
          color="secondary"
          variant="outlined"
          onClick={(e) => {
            e.preventDefault();
            onCancel();
          }}
        >
          Cancel
        </Button>
      </ActionButtonWrapper>
    </Form>
  );
};

RenameEventDocForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
RenameEventDocForm.defaultProps = {
  name: '',
};

export default RenameEventDocForm;
